<template>
   <v-sheet style="background-color:#fff;height:100%">
    <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" pb-5>
                    <v-btn :to="{name:'reports'}" icon text dark>
                        <v-icon color="black">arrow_back</v-icon>
                    </v-btn>

                    <v-toolbar-title class="text-uppercase">RELATÓRIOS {{platform}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
    <v-container fluid >
      <v-card v-if="series!==false" elevation="0">
            <apexchart type="line" height="350" :options="chart_options" :series="series"></apexchart>
      </v-card>
      <v-data-table 
        :headers="headers"
        :items="resultado"        
        multi-sort
        :items-per-page="200"
        class="elevation-0 mt-3"
        fixed-header
    >
     <template v-slot:item.i_date="{item}">
            {{String(item.i_date).substr(4,2)+"/"+String(item.i_date).substr(0,4)}}
        </template>
        <template v-slot:item.val_partner="{item}">
            {{item.s_currency}} {{item.val_partner}}
        </template>
    </v-data-table>

    </v-container>

   </v-sheet>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

import ReportsService from "../../../app/Rest/reports";
var reportsService = null;

import { money } from "../../../app/general";
var _money = new money();

export default {
     components: {
          apexchart: VueApexCharts,
        },  
    data: () => ({
               
       platform: null,
       resultado:[],
       headers:[
          { text: 'Período', align: 'left', sortable: false,value: 'i_date' },
          { text:'Track/Vídeo', value:'pct_track_name'},
          { text: 'ISRC', value: 's_isrc' },
          { text: 'UPC', value: 's_upc' },          
          { text: 'Plays/Views', value: 'qtd' },          
          { text: 'Valor', value: 'val_partner' }          
        ],
        chart_data:{},
        chart_labels:[]
        
    }),
    computed:{
        series: function(){
            let keys = Object.keys(this.chart_data);

            if(keys.length<=1){
                return false;
            }

            let qtd = [];
            let val = [];
            this.chart_labels = keys;

            keys.forEach( (item,index)=>{
                
                qtd.push(this.chart_data[item].qtd);
                val.push(this.chart_data[item].val);
            });

            return [{
            name: 'Plays/Views',
            type: 'column',
            data: qtd
          }, {
            name: 'Valor',
            type: 'line',
            data: val
          }]
        },
        chart_options: function(){
            return {
                chart: {
                        zoom:{
                            enabled:false,
                        },
                        height: 350,
                        type: 'line',
                    },
                    stroke: {
                        width: [0, 4]
                    },
                    title: {
                        text: ''
                    },
                    dataLabels: {
                        enabled: true,
                        enabledOnSeries: [1]
                    },
                    labels: this.chart_labels,
                    xaxis: {
                        
                        type: 'category'
                    },
                    yaxis: [{
                        decimalsInFloat:0,
                        title: {
                            text: 'Views/Plays',
                        },
                        
                        }, 
                        {
                            decimalsInFloat:3,
                        opposite: true,
                        title: {
                            text: 'Valor'
                        }
                    }]
            }
        }
    },
    created(){
        this.platform = this.$route.params.platform;   
         reportsService = ReportsService.build(); 
         this.loadPlatformReports();  
          
    },
    mounted(){
        
    },
    methods:{
        loadPlatformReports(){ 
            this.$store.commit("loading"); 
            reportsService.get_platform(this.platform.toLowerCase()).then(e=>{
                this.resultado = e.items.rows;
                this.chart_data = e.items.chart;
            }).finally(()=>{
                this.$store.commit("loading", false);
            });
        },
        formatarDinheiro(valor, moeda="R$", casas=2) {
            let t = valor;
            _money.set_currency(moeda)
            return _money.formatWithCurrency(t, casas, ",");
        }
    }
};
</script>
